/* eslint-disable no-undef */
/* eslint-disable camelcase */
import {
  printNoDataChart,
  printDataChart,
  getCommonOptions,
  initChart,
  calculateXAxisMonth,
  calculateXAxisStart,
  filterDatesUpdate,
} from '../common';
import { COLORS } from '../constants/constants';

let chartUsuarisPerTitol;
let chartUsuarisPerTitolLine;
let dataZoomUsuarisPerTitol = {
  start: undefined,
  end: undefined,
};
let chartUsuarisPerLinea;
let chartUsuarisPerLineaLine;
let dataZoomUsuarisPerLinea = {
  start: undefined,
  end: undefined,
};
function initFilter(checkList) {
  let counter = 0;
  const $inputsDate = $('#formFilterDates').find('input');
  $($inputsDate).each((index) => {
    counter += 1;
    $inputsDate[index].checked = true;
  });

  counter = 0;
  const $inputsEMT1 = $('#formFilterEMT1').find('input');
  $($inputsEMT1).each((index) => {
    counter += 1;
    if (counter <= 6) {
      $inputsEMT1[index].checked = true;
    }
  });

  const $inputsEMT2 = $('#formFilterEMT2').find('input');
  $($inputsEMT2).each((index) => {
    if (checkList) {
      if (checkList.includes($inputsEMT2[index].id)) {
        counter += 1;
        if (counter <= 6) {
          $inputsEMT2[index].checked = true;
        }
      }
    }
  });

  counter = 0;
  const $inputsVar = $('#formFilterVar').find('input');
  $($inputsVar).each((index) => {
    counter += 1;
    if (counter <= 2) {
      $inputsVar[index].checked = true;
    }
  });

  if (Dashboards.getParameterValue('filterDatesParam').length > 0) {
    Dashboards.fireChange('filterDatesParam');
    // eslint-disable-next-line camelcase
    render_echartAccessosCiutat.listeners = ['filterDatesParam'];
    Dashboards.fireChange('filterDatesParam');
    // eslint-disable-next-line camelcase
    render_echartAccessosCiutat.listeners = [''];
  }

  if (Dashboards.getParameterValue('filterEMT2Param').length > 0) {
    Dashboards.fireChange('filterEMT2Param');
  }
  if (Dashboards.getParameterValue('filterVarParam').length > 0) {
    Dashboards.fireChange('filterVarParam');
  }
}
export function clearInputs(checkList = null) {
  let $inputsDate = $('#formFilterDates').find('input');
  $inputsDate = $('#formFilterDates').find('input');
  $($inputsDate).each((index, element) => {
    if (element.checked) $inputsDate[index].checked = false;
  });

  const $inputsEMT1 = $('#formFilterEMT1').find('input');
  $($inputsEMT1).each((index, element) => {
    if (element.checked) $inputsEMT1[index].checked = false;
  });
  if (checkList) {
    const $inputsEMT2 = $('#formFilterEMT2').find('input');
    $($inputsEMT2).each((index, element) => {
      if (element.checked) $inputsEMT2[index].checked = false;
    });
  }
  const $inputsVar = $('#formFilterVar').find('input');
  $($inputsVar).each((index, element) => {
    if (element.checked) $inputsVar[index].checked = false;
  });
  initFilter(checkList);
}
export function filterEMT1Update() {
  // Guardamos el estado del datazoom en el caso de que ya exista
  if (chartUsuarisPerTitol) {
    [dataZoomUsuarisPerTitol] = chartUsuarisPerTitol.getOption().dataZoom;
  }
  const $inputsDate = $('#formFilterEMT1').find('input');
  const paramDate = [];
  $($inputsDate).each((index, element) => {
    if (element.checked) paramDate.push(element.id);
  });
  Dashboards.fireChange('filterEMT1Param', paramDate);
  Dashboards.fireChange('updateFilterEMT1', 'True');
}

function createCheckBoxFilterEMT1(sizeOfCheckBox, uniqueData) {
  const $container = $('#formFilterEMT1');
  if (Dashboards.getParameterValue('updateFilterEMT1') === '') {
    uniqueData.forEach((value) => {
      $container.append(
        `<input type="checkbox" id="${value}" class="titol-${value}" onclick="emt.filterEMT1Update();" /> ${value} </br>`,
      );
    });
    clearInputs();
    filterDatesUpdate();
    filterEMT1Update();
  }
}

export function filterEMT2Update() {
  // Guardamos el estado del datazoom en el caso de que ya exista
  if (chartUsuarisPerLinea) {
    [dataZoomUsuarisPerLinea] = chartUsuarisPerLinea.getOption().dataZoom;
  }
  const $inputsDate = $('#formFilterEMT2').find('input');
  const paramDate = [];
  $($inputsDate).each((index, element) => {
    if (element.checked) paramDate.push(element.id);
  });
  Dashboards.fireChange('filterEMT2Param', paramDate);
  Dashboards.fireChange('updateFilterEMT2', 'True');
}

function createCheckBoxFilterEMT2(sizeOfCheckBox, uniqueData, checkList) {
  const $container = $('#formFilterEMT2');
  if (Dashboards.getParameterValue('updateFilterEMT2') === '') {
    uniqueData.forEach((value) => {
      $container.append(
        `<input type="checkbox" id="${value}" class="linea-${value}" onclick="emt.filterEMT2Update();" />`,
      );
    });
    clearInputs(checkList);
    filterDatesUpdate();
    filterEMT2Update();
  }
}

/**
 * Devuelve un array con todos los caracteres no numericos encontrados en las key de un map.
 * @param {Map} inputMap Map proporcionado
 * @returns Un array con todos los caracteres no numericos encontrados.
 */
function getWordsFromMapKeys(inputMap) {
  const outputArray = [];
  inputMap.forEach((valor, clave) => {
    Array.from(clave).forEach((word) => {
      if (!outputArray.includes(word) && Number.isNaN(Number(word))) {
        outputArray.push(word);
      }
    });
  });
  return outputArray;
}

/**
 * Devuelve el mismo Map proporcionado pero solo con los elementos indicados
 * @param {Map} inputMap Map proporcionado
 * @param {String} [type=number] "number" si quieres quedarte con los ids que son solo numericos.
 * "includes" para los ids que contengan el string indicado en value.
 * @param {String} [value=null] Valor contendra el id si el type es "includes"
 * @returns Un nuevo Map que contendra los elementos indicados.
 */
function getMapWithIdCondition(inputMap, type = 'number', value = null) {
  let outputMap;
  if (type === 'number') {
    outputMap = new Map(
      [...inputMap].filter(([key]) => !Number.isNaN(Number(key))),
    );
  } else if (type === 'includes') {
    outputMap = new Map([...inputMap].filter(([key]) => key.includes(value)));
  }
  return outputMap;
}

/**
 * Recibe un Map y lo devuelve habiendo quitado todos los caracteres de su key excepto los numeros.
 * @param {Map} inputMap Input Map que contiene numeros en todas sus key Ej:N1,N2,N3.
 * @returns Devuelve un Map pero las key pasan a ser un Array con un elemento numerico Ej:["1"]
 * Al introducir un array como key, pueden repetirse las key.
 */
function changeMapKeysToOnlyInteger(inputMap) {
  const regex = /\d+/g;
  const mapIntKey = new Map();
  inputMap.forEach((key) => {
    mapIntKey.set(key.match(regex), inputMap.get(key));
  });
  return mapIntKey;
}

/**
 * Recibe un Map y lo devuelve ordenado por key de forma numerica
 * @param {Map} inputMap Input Map que debe contener keys numericas. Ej:2,3,1
 * @returns Devuelve el mismo Map pero ordenado por las keys numericamente ascendente. Ej:1,2,3
 */
function sortMapByNumericKey(inputMap) {
  // Convierte las claves en un Array y lo ordena numéricamente
  const sortedKeys = Array.from(inputMap.keys()).sort((a, b) => a - b);

  // Crea un nuevo objeto Map con las claves ordenadas
  const sortedMap = new Map();
  sortedKeys.forEach((key) => {
    sortedMap.set(key, inputMap.get(key));
  });
  return sortedMap;
}

export function chargeData(filterTipos, misDatosArray, isMap = false) {
  const COL_TIPO = 0;
  const COL_FECHA = 1;
  const COL_DATO = 2;
  const dataObj = [];
  const date = new Set();
  const tipos = isMap ? new Map() : new Set();
  for (let i = 0; i < misDatosArray.length; i += 1) {
    if (
      filterTipos.length === 0 ||
      filterTipos.includes(misDatosArray[i][COL_TIPO])
    ) {
      if (isMap) {
        tipos.set(misDatosArray[i][COL_TIPO], misDatosArray[i][COL_TIPO]);
      } else tipos.add(misDatosArray[i][COL_TIPO]);
      dataObj.push({
        day: misDatosArray[i][COL_FECHA],
        type: misDatosArray[i][COL_TIPO],
        value: misDatosArray[i][COL_DATO],
      });
      date.add(misDatosArray[i][COL_FECHA]);
    }
  }
  return [tipos, dataObj, Array.from(date.values())];
}

export function createSerie(filterTipos, dataObj, datesArray) {
  const colors = COLORS.slice();
  return filterTipos.map((filterTipo) => {
    const arrayData = dataObj.filter((obj) => obj.type === filterTipo);
    const arrayDataClean = datesArray.map((date) => {
      const indexObj = arrayData.findIndex((obj) => obj.day === date);
      return indexObj !== -1 ? arrayData[indexObj].value : null;
    });
    return {
      name: filterTipo,
      type: 'line',
      symbol: 'circle',
      color: colors.shift(),
      symbolSize: 6,
      smooth: false,
      data: arrayDataClean,
    };
  });
}

function orderData(dataObj) {
  const acumuladorPorTipo = {};
  dataObj.forEach((registro) => {
    const tipo = registro.type;
    const valor = registro.value;
    acumuladorPorTipo[tipo] = (acumuladorPorTipo[tipo] || 0) + valor; // Si no existe, inicializo 0
  });
  const tiposConValor = Object.keys(acumuladorPorTipo).map((tipo) => ({
    tipo,
    valor: acumuladorPorTipo[tipo],
  }));

  tiposConValor.sort((a, b) => b.valor - a.valor);

  return tiposConValor.map((objeto) => objeto.tipo);
}

export function echartLineTitol(
  idChart,
  idChartNoData,
  misDatosArray,
  titleChart,
  isHistoric,
) {
  const filterTipos = Dashboards.getParameterValue('filterEMT1Param');
  if (misDatosArray.length === 0) {
    printNoDataChart(`#${idChart}`, `#${idChartNoData}`);
  } else {
    printDataChart(`#${idChartNoData}`, `#${idChart}`);
    // eslint-disable-next-line no-unused-vars
    const [tipos, dataObj, datesArray] = chargeData(filterTipos, misDatosArray);

    if (!isHistoric) {
      const tiposUnicosOrdenados = orderData(dataObj);
      // const tiposArray = Array.from(tipos);
      createCheckBoxFilterEMT1(
        tiposUnicosOrdenados.length,
        tiposUnicosOrdenados,
      );
      if (filterTipos) {
        filterTipos.sort((a, b) => a.localeCompare(b));
      }
    }
    if (filterTipos) {
      const seriesEMTTitol = createSerie(filterTipos, dataObj, datesArray);
      const xAxisStart = isHistoric
        ? calculateXAxisMonth(datesArray.length)
        : calculateXAxisStart(datesArray.length);
      const NAME_MARGIN_Y = -10;
      const option = getCommonOptions(
        seriesEMTTitol,
        filterTipos,
        datesArray,
        'Viatges',
        xAxisStart,
        true,
        NAME_MARGIN_Y,
        undefined,
        titleChart,
        dataZoomUsuarisPerTitol.start,
        dataZoomUsuarisPerTitol.end,
      );
      let chart;
      if (isHistoric) {
        chartUsuarisPerTitolLine = initChart(idChart, option);
        chart = chartUsuarisPerTitolLine;
      } else {
        chartUsuarisPerTitol = initChart(idChart, option);
        chart = chartUsuarisPerTitol;
      }

      const numFilterTiposChecked = $('#formFilterEMT1 :checked').length;
      if (numFilterTiposChecked === 0) {
        printNoDataChart(`#${idChart}`, `#${idChartNoData}`);
      }

      $(window).on('resize', () => {
        if (chart != null && chart !== undefined) {
          chart.resize();
        }
      });
    }
  }
}

export function echartLineLinia(
  idChart,
  idChartNoData,
  misDatosArray,
  titleChart,
  isHistoric,
) {
  const filterTipos = Dashboards.getParameterValue('filterEMT2Param');
  if (misDatosArray.length === 0) {
    printNoDataChart(`#${idChart}`, `#${idChartNoData}`);
  } else {
    printDataChart(`#${idChartNoData}`, `#${idChart}`);
    const [tipos, dataObj, datesArray] = chargeData(
      filterTipos,
      misDatosArray,
      true,
    );
    if (!isHistoric) {
      // Elaboración de array con las lineas ordenadas
      const lineasNormalesOrdenadas = Array.from(
        sortMapByNumericKey(getMapWithIdCondition(tipos, 'number')).values(),
      );
      let lineasEspecialesOrdenadas = [];

      const tiposEspeciales = getWordsFromMapKeys(tipos);
      tiposEspeciales.forEach((element) => {
        lineasEspecialesOrdenadas = lineasEspecialesOrdenadas.concat(
          Array.from(
            sortMapByNumericKey(
              changeMapKeysToOnlyInteger(
                getMapWithIdCondition(tipos, 'includes', element),
              ),
            ).values(),
          ),
        );
      });
      let tiposArray = lineasNormalesOrdenadas.concat(
        lineasEspecialesOrdenadas,
      );

      // Quitar las duplicidades
      tiposArray = [...new Set(tiposArray)];

      const checkList = orderData(dataObj).slice(0, 6);
      createCheckBoxFilterEMT2(tiposArray.length, tiposArray, checkList);
    }
    if (filterTipos) {
      const seriesEMTLinia = createSerie(filterTipos, dataObj, datesArray);
      const xAxisStart = calculateXAxisStart(datesArray.length);
      const NAME_MARGIN_Y = -10;

      const option = getCommonOptions(
        seriesEMTLinia,
        filterTipos,
        datesArray,
        'Viatges',
        xAxisStart,
        true,
        NAME_MARGIN_Y,
        undefined,
        titleChart,
        dataZoomUsuarisPerLinea.start,
        dataZoomUsuarisPerLinea.end,
      );

      let chart;
      if (isHistoric) {
        chartUsuarisPerLineaLine = initChart(idChart, option);
        chart = chartUsuarisPerLineaLine;
      } else {
        chartUsuarisPerLinea = initChart(idChart, option);
        chart = chartUsuarisPerLinea;
      }

      const numFilterTiposChecked = $('#formFilterEMT1 :checked').length;
      if (numFilterTiposChecked === 0) {
        printNoDataChart(`#${idChart}`, `#${idChartNoData}`);
      }

      $(window).on('resize', () => {
        if (chart != null && chart !== undefined) {
          chart.resize();
        }
      });
    }
  }
}
// //Eventos
export function handlerActivarFiltro() {
  document.querySelector('#idFiltrar').style.visibility = 'visible';
}
export function handlerDesactivarFiltro() {
  document.querySelector('#idFiltrar').style.visibility = 'hidden';
}
export function filterData(misDatosArray, filterTipos) {
  return misDatosArray.filter((dato) => filterTipos.includes(dato[0]));
}
export function listeneresEMT() {
  const listenersFilterTitol = [
    'filterDatesParam',
    'updateFilter',
    'filterEMT1Param',
    'updateFilterEMT1',
  ];
  const listenersFilterLinia = [
    'filterDatesParam',
    'updateFilter',
    'filterEMT2Param',
    'updateFilterEMT2',
  ];

  render_echartUsuarisPerLinea.listeners = listenersFilterLinia;
  render_echartUsuarisPerLiniaLineMonth.listeners = listenersFilterLinia;
  render_echartUsuarisPerLiniaGaugeYear.listeners = listenersFilterLinia;
  render_echartUsuarisPerLiniaGaugeMonth.listeners = listenersFilterLinia;
  render_echartUsuarisPerLiniaBarYear.listeners = listenersFilterLinia;

  render_echartUsuarisPerTitol.listeners = listenersFilterTitol;
  render_echartUsuarisPerTitolLineMonth.listeners = listenersFilterTitol;
  render_echartUsuarisPerTitolGaugeYear.listeners = listenersFilterTitol;
  render_echartUsuarisPerTitolGaugeMonth.listeners = listenersFilterTitol;
  render_echartUsuarisPerTitolBarYear.listeners = listenersFilterTitol;
  // eslint-disable-next-line camelcase
  render_echartUsuarisTotals.listeners = ['filterDatesParam', 'updateFilter'];

  Dashboards.fireChange('filterDatesParam');
  Dashboards.fireChange('updateFilter');
  Dashboards.fireChange('filterEMT1Param');
  Dashboards.fireChange('updateFilterEMT1');
  Dashboards.fireChange('filterEMT2Param');
  Dashboards.fireChange('updateFilterEMT2');
}
